module.exports = __webpack_public_path__ + "static/media/ill_placeholder.05a8dbe3.svg";